import $ from 'jquery'
import jump from 'jump.js'

import './property-detail-page-modules/_gallery'
import './property-detail-page-modules/_modal-init'
import './property-detail-page-modules/_youtube-video-modal'
import './property-detail-page-modules/_google-map'
import './property-detail-page-modules/_newsletter'

$('#jump_anchors_js a:not(.no-jump)').on('click', function (event) {
	event.preventDefault()

	jump($(this).attr('href'), {
		offset: -30,
		a11y: true,
	})
})

$('.disable-click').on('click', function (event) {
	event.preventDefault()
})
